import { render, staticRenderFns } from "./edit-trading-style.vue?vue&type=template&id=d3c607c8&"
import script from "./edit-trading-style.vue?vue&type=script&lang=js&"
export * from "./edit-trading-style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports